import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, renderSlot as _renderSlot, createElementVNode as _createElementVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", null, [
    _createElementVNode("span", {
      "aria-hidden": "true",
      class: _normalizeClass('icon-' + _ctx.icon)
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paths, (path, index) => {
        return (_openBlock(), _createElementBlock("span", {
          key: index,
          class: _normalizeClass('path' + index)
        }, null, 2))
      }), 128)),
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ], 2)
  ]))
}